// Card Element applies to opp_ payment options except installments and UnionPay (formerly Optimizely flag PAAR-6964-CardElementFlow, hardcoded in PAAR-7642 for checkout and PAAR-7641 for Payex)
export const CARD_ELEMENT_PAYMENT_OPTION_PATTERN = 'opp_';
export const CARD_ELEMENT_EXCLUDED_PAYMENT_OPTION_PATTERNS = [
  'installment',
  'unionpay',
];
